import React from "react";
import FloatingLines from "./FloatingLines";

const Hero = () => {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden bg-black"
    >
      {/* Floating lines background */}
      <div className="absolute inset-0">
        <FloatingLines
          enabledWaves={["top", "middle", "bottom"]}
          lineCount={[10, 15, 20]}
          lineDistance={[8, 6, 4]}
          bendRadius={5.0}
          bendStrength={-0.5}
          interactive
          parallax
          animationSpeed={1}
          linesGradient={["#1D4ED8", "#2563EB", "#4F46E5", "#EC4899"]}
        />
      </div>

      {/* Soft overlay for readability */}
      <div className="absolute inset-0 pointer-events-none bg-gradient-to-b from-slate-950/70 via-slate-950/40 to-slate-950/80" />

      {/* Text content, no card */}
      <div className="relative z-10 w-full">
        <div className="max-w-5xl mx-auto px-6 py-24 md:py-32">
          <div className="space-y-4 text-left text-white max-w-3xl">
            <h1 className="heading-hero">
              <span className="bg-gradient-to-r from-white to-gray-200 bg-clip-text text-transparent">
                Andy Persaud
              </span>
            </h1>

            <p className="text-xl md:text-2xl font-medium text-indigo-100">
              Lead Web Strategist | AI-Powered UX & Product Experiences
            </p>

            {/* Specialties chips */}
            <div className="mt-4 flex flex-wrap gap-2">
              {[
                "UX/UI Design",
                "GenAI",
                "Project Management",
              ].map((label) => (
                <span
                  key={label}
                  className="px-3 py-1 rounded-full text-sm font-medium bg-white/10 border border-white/20 text-indigo-100/90 backdrop-blur-sm"
                >
                  {label}
                </span>
              ))}
            </div>

            {/* Signature line */}
            <p className="mt-4 text-sm md:text-base text-indigo-100/80">
              Based in New York City - Open to remote and hybrid roles
            </p>

          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="backdrop-blur-md bg-white/10 border border-white/20 rounded-full p-3 hover:bg-white/15 transition-all duration-300">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center animate-bounce">
            <div className="w-1 h-3 bg-white/70 rounded-full mt-2 animate-pulse" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;